// dependencies imports ⇒
import React, { useEffect, useState } from "react";
// assets and scss imports ⇒
import "./patientAbhaVerification.scss";
import backArrow from "../../../assets/back_arrow_gray.svg";
// project file imports(UI components) ⇒
import AbhaVerifcation from "./AbhaVerification";
import { PATIENT_ABHA_VERIFICATION_TAB } from "../Constants";
import AadhaarVerification from "./AadhaarVerification";
import MobileNumberVerification from "./MobileNumberVerification";
import FormInputWithHeader from "../../common/FormInputWithHeader";
// const file imports(helper methods, etc) ⇒

const PatientAbhaVerification = (props) => {
  // const declarations ⇒
  const {
    patientDetails,
    hfrId,
    handleAadharAbhaVerification,
    populateAbhaAddress,
    populateAbhaDetails,
  } = props;

  const [activeTab, setActiveTab] = useState(1);
  const [aadharSteps, setAadharSteps] = useState(1);
  const [abhaNumberStep, setAbhaNumberStep] = useState(1);
  const [mobileNumberStep, setMobileNumberStep] = useState(1);

  const [existingPatientDetails, setExistingPatientDetails] = useState({});
  const [enteredMobileNumber, setEnteredMobileNumber] = useState("");
  const [disableAbhaAadharTabs, setDisableAbhaAadharTabs] = useState(false);

  // let or var declarations ⇒

  // life cycle methods ⇒
  useEffect(() => {
    setExistingPatientDetails({
      patient_name: patientDetails?.patient_name,
      patient_dob: patientDetails?.patient_dob
        ? patientDetails?.patient_dob
        : patientDetails?.dob,
      patient_gender: patientDetails?.patient_gender,
      patient_address: patientDetails?.patient_address,
      patient_state: patientDetails?.state_name
        ? patientDetails?.state_name
        : patientDetails?.patient_state_name,
      patient_account_id: patientDetails?.patient_account_id
        ? patientDetails?.patient_account_id
        : "",
      patient_mobile_no: patientDetails?.patient_no,
    });
    setEnteredMobileNumber(patientDetails?.patient_no);
  }, [patientDetails]);

  // API Calls ⇒

  // Helper methods ⇒

  // Actions ⇒

  const handleMobileNumberChange = (number) => {
    setEnteredMobileNumber(number);
  };

  const handleSteps = (step) => {
    setAadharSteps(step);
  };

  const handleAbhaNumberSteps = (step) => {
    setAbhaNumberStep(step);
  };

  const handleMobileNumberSteps = (step) => {
    setMobileNumberStep(step);
  };

  const handleRightArrowBtn = () => {
    setDisableAbhaAadharTabs(true);
  };

  const handleBack = () => {
    handleAadharAbhaVerification();
  };

  const handleActiveTab = (id) => {
    setActiveTab(id);
  };

  const getSelectedTabHeader = (activeTab) => {
    return activeTab === 1
      ? "Aadhar Number"
      : activeTab === 2
      ? "ABHA Number"
      : "Mobile Number";
  };

  // create UI ⇒

  const patientAbhaVericationHeader = () => {
    return (
      <div className="pavc-header-container">
        {((activeTab === 1 && aadharSteps === 1) ||
          (activeTab === 2 && abhaNumberStep === 1) ||
          (activeTab === 3 &&
            (mobileNumberStep === 1 || mobileNumberStep === 3))) && (
          <img
            src={backArrow}
            alt=""
            className="pavc-back-btn"
            onClick={handleBack}
          />
        )}
        <div className="pavc-heading">
          Link Patients With {getSelectedTabHeader(activeTab)}:
        </div>
      </div>
    );
  };

  const displayTabHeader = () => {
    return (
      <div className="pavc-tabs-header">
        {PATIENT_ABHA_VERIFICATION_TAB.map((data) => (
          <>
            <div
              className={
                "pavc-tabs " +
                (activeTab === data?.id ? "pavc-tab-selected" : "")
              }
              key={data.id}
              onClick={() =>
                disableAbhaAadharTabs ? "" : handleActiveTab(data?.id)
              }
              style={{ cursor: disableAbhaAadharTabs ? "not-allowed" : "" }}
            >
              {data?.label}
            </div>
            <span
              className={`pavc-tabs-right-border ${data?.name}-right-border`}
            ></span>
          </>
        ))}
      </div>
    );
  };

  const displayTabContent = () => {
    return (
      <div className="pavc-tab-content">
        {activeTab === 1 && (
          <AadhaarVerification
            aadharSteps={aadharSteps}
            enteredMobileNumber={enteredMobileNumber}
            existingPatientDetails={existingPatientDetails}
            handleMobileNumberChange={handleMobileNumberChange}
            handleSteps={handleSteps}
            handleSubmitExistingPatientDetails={populateAbhaAddress}
            handleSubmitAbhaPatientDetails={populateAbhaDetails}
            handleBack={handleAadharAbhaVerification}
          />
        )}
        {activeTab === 2 && (
          <AbhaVerifcation
            abhaNumberStep={abhaNumberStep}
            hfrId={hfrId}
            existingPatientDetails={existingPatientDetails}
            handleSubmitExistingPatientDetails={populateAbhaAddress}
            handleSubmitAbhaPatientDetails={populateAbhaDetails}
            handleAbhaNumberSteps={handleAbhaNumberSteps}
            handleBack={handleAadharAbhaVerification}
          />
        )}
        {activeTab === 3 && (
          <MobileNumberVerification
            mobileNumberStep={mobileNumberStep}
            hfrId={hfrId}
            existingPatientDetails={existingPatientDetails}
            handleSubmitExistingPatientDetails={populateAbhaAddress}
            handleSubmitAbhaPatientDetails={populateAbhaDetails}
            handleMobileNumberSteps={handleMobileNumberSteps}
            handleRightArrowBtn={handleRightArrowBtn}
            handleBack={handleAadharAbhaVerification}
          />
        )}
      </div>
    );
  };

  const displayAbhaSelectionDropdown = () => {
    let selectedVal = PATIENT_ABHA_VERIFICATION_TAB.filter(
      (data) => data?.id === activeTab
    )[0].label;
    return (
      <div className="abha-selection-dropdown-container">
        <FormInputWithHeader
          className="abha-selection-dropdown"
          value={selectedVal}
          selectedOption={activeTab}
          inputType="dropdown"
          placeholder="Select One"
          options={PATIENT_ABHA_VERIFICATION_TAB}
          handleOnChangeInput={(item) => {
            setActiveTab(item.id);
          }}
        ></FormInputWithHeader>
      </div>
    );
  };

  const getTabHeader = () => {
    return (
      <>
        {displayTabHeader()}
        {displayAbhaSelectionDropdown()}
      </>
    );
  };

  const displayPatientVerificationTab = () => {
    return (
      <div className="pavc-tab">
        {((activeTab === 1 && aadharSteps === 1) ||
          (activeTab === 2 && abhaNumberStep === 1) ||
          (activeTab === 3 && mobileNumberStep === 1)) &&
          getTabHeader()}
        {displayTabContent()}
      </div>
    );
  };

  const patientAbhaVerificationUI = () => {
    return (
      <div className="pavc-main">
        {((activeTab === 1 && aadharSteps !== 5) ||
          activeTab === 2 ||
          (activeTab === 3 && [1, 2, 3].includes(mobileNumberStep))) &&
          patientAbhaVericationHeader()}
        {displayPatientVerificationTab()}
      </div>
    );
  };
  return (
    <div className="patient-abha-verification-container">
      {patientAbhaVerificationUI()}
    </div>
  );
};

// export ⇒

export default PatientAbhaVerification;
